export default __webpack_public_path__ + "c947dcd20eb9c5d5457525d419eae47a.svg";